import { BackButton, Button, Text } from '@/components';
import APP_CONFIG from '@/config/app';
import { FC } from 'react';
import { TrayHeaderProps } from './interfaces/Tray';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const {
  MAIN_GAP,
  WHOLESTEP_DECREMENT,
  TEXT: { BIG_HEADING, BIG_HEADING_COLOR },
} = APP_CONFIG.STYLES;
const spacingConfig = {
  padding: 'p-0',
  gap: `gap${MAIN_GAP}`,
  headerLeftNodePadding: 'p-0',
  headerLeftNodeGap: 'gap-0',
  headerCenterNodePadding: 'inset-0',
  headerCenterNodeGap: `gap${MAIN_GAP}${WHOLESTEP_DECREMENT}`,
  headerRightNodePadding: 'p-0',
  headerRightNodeGap: `gap${MAIN_GAP}${WHOLESTEP_DECREMENT}`,
};
const sizingConfig = {
  height: 'h-xl',
  width: 'w-full',
  headerLeftNodeHeight: 'h-full',
};
const colorConfig = {
  background: 'bg-none',
  border: 'border-none',
};
const textConfig = {
  headingSize: BIG_HEADING,
  headingColor: BIG_HEADING_COLOR,
};
const TrayHeader: FC<TrayHeaderProps> = ({
  title,
  onClose,
  onNavigateBack,
  headerNode,
  rightButtons,
  showCloseButton = true,
}) => (
  <div
    className={`relative flex-shrink-0 flex flex-row justify-between items-center 
      ${spacingConfig.padding} 
      ${spacingConfig.gap} 
      ${sizingConfig.width} 
      ${sizingConfig.height}
      ${colorConfig.background}
      ${colorConfig.border}
      ${borderClassToVisualizeElementsAndSpacing}`}
  >
    <div
      className={`flex items-center 
        ${spacingConfig.headerLeftNodePadding}
        ${spacingConfig.headerLeftNodeGap} 
        ${sizingConfig.headerLeftNodeHeight}  
        ${borderClassToVisualizeElementsAndSpacing}`}
    >
      {onNavigateBack && (
        <BackButton
          onBackClick={onNavigateBack}
          className={`${borderClassToVisualizeElementsAndSpacing}`}
        />
      )}
    </div>
    <div
      className={`absolute flex justify-center items-center pointer-events-none text-center 
        ${spacingConfig.headerCenterNodePadding} 
        ${spacingConfig.headerCenterNodeGap} 
        ${borderClassToVisualizeElementsAndSpacing}`}
    >
      {headerNode ? (
        headerNode
      ) : (
        <Text
          value={title}
          size={textConfig.headingSize}
          color={textConfig.headingColor}
          className={borderClassToVisualizeElementsAndSpacing}
        />
      )}
    </div>
    <div
      className={`flex flex-row justify-end items-center
        ${spacingConfig.headerRightNodePadding} 
        ${spacingConfig.headerRightNodeGap} 
        ${borderClassToVisualizeElementsAndSpacing}`}
    >
      {rightButtons?.map((buttonProps, index) => (
        <Button key={index} {...buttonProps}>
          {buttonProps.children}
        </Button>
      ))}
      {showCloseButton && (
        <Button
          onClick={onClose}
          className={`${borderClassToVisualizeElementsAndSpacing}`}
          intent="ghost"
          icon="close"
          iconStyles={{ intent: 'accent' }}
        />
      )}
    </div>
  </div>
);
export default TrayHeader;
